import { render, staticRenderFns } from "./manageGoods.vue?vue&type=template&id=e5a1c2fe&scoped=true&"
import script from "./manageGoods.vue?vue&type=script&lang=js&"
export * from "./manageGoods.vue?vue&type=script&lang=js&"
import style0 from "./manageGoods.vue?vue&type=style&index=0&id=e5a1c2fe&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5a1c2fe",
  null
  
)

export default component.exports